/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-26, 10:33:12
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 10:43:07
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import { API, API_URL } from '@/config';
import { togglePendingStoreActions } from '@/utils/decorators';

import {
  FILL_FAQ_LIST,
} from './mutation-types';

export default {
  @togglePendingStoreActions()
  async getFaqList({ commit }) {
    const faqList = (await API.get(`${API_URL}/faq`)).data.data;
    commit(FILL_FAQ_LIST, { faqList });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/Help/actions.js